import styled, { css } from 'styled-components'

export const DateSelectorView = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 60px;
`

export const SelectorTitle = styled.span`
  ${({ theme }) => css`
    font-size: 20px;
    color: ${theme.colors.text};
    font-family: ${theme.fonts.title};
    font-weight: ${theme.fonts.titleWeight};
  `};
`
